export default "__VITE_ASSET__e$RifcPS__"